import { createShell } from '../shell/createShell';
import App from './App';
import { evaluateMembershipProduct } from '../pages/Payment/integrationOf1';
import { homeLoginPopUp } from '../funnels/Authentication/components/LoginMenu/integrationOf1';
import { eventRequestHandler, EVENTS, OFFERED_INSURANCES_IN_CMF } from '@edreamsodigeo/frontend-additional-products';
import postBookingSeats from '../boundaries/postBookingSeats';
import cabinBags from '../boundaries/cabinBags';
import { createFlightResultsActions } from '../funnels/FlightResults/integration/frontend-html5.actions';
import { createIntegration } from './frontend-html5.integration';
import { createAppProps } from './App.props';
import flexibilityBundle from '../boundaries/flexibilityBundle';
import { traveller } from '../funnels/Checkout/components/PassengersPage/integrationOF1';
import { route as resultsRoute } from '../funnels/FlightResults/pages/results';
import { route as pfHomeRoute } from '../funnels/PriceFreeze/pages/pfhome';
import { route as pfOffersRoute } from '../funnels/PriceFreeze/pages/pfoffers';
import { route as pfPaxRoute } from '../funnels/PriceFreeze/pages/pfpax';
import { route as pfPaymentRoute } from '../funnels/PriceFreeze/pages/pfpayment';
import { route as pfConfirmationRoute } from '../funnels/PriceFreeze/pages/pfconfirmation';
import { route as mrcpRoute } from '../funnels/MembershipPages/pages/membershipReferralConfirmationPage/membershipReferralConfirmationPage';
import { route as mrspRoute } from '../funnels/MembershipPages/pages/membershipReferralSenderPage/membershipReferralSenderPage';
import { route as mrrpRoute } from '../funnels/MembershipPages/pages/membershipReferralReceiverPage/membershipReferralReceiverPage';
import { route as mStandaloneCampaignRoute } from '../funnels/MembershipPages/pages/membershipStandaloneCampaigns/membershipStandaloneCampaignsUserInfoPage';
import { route as mStandaloneCheckoutRoute } from '../funnels/MembershipPages/pages/membershipStandaloneCampaigns/membershipStandaloneCampaignsCheckoutPage';
import { route as mStandaloneConfirmationRoute } from '../funnels/MembershipPages/pages/membershipStandaloneCampaigns/membershipStandaloneCampaignsConfirmationPage';
import { route as semResultsRoute } from '../funnels/SemResults/pages/sem_results';
import { route as myTripsReactivationRoute } from '../funnels/MembershipPages/pages/membershipMyTripsReactivation/membershipMyTripsReactivationPage';
import { route as babilling_detailsRoute } from '../funnels/Invoices/pages/billing-details';
import { route as barequest_invoiceRoute } from '../funnels/Invoices/pages/request-invoice';
import { route as baconfirmationRoute } from '../funnels/Invoices/pages/confirmation';
import { route as cnxFlightSelectorRoute } from '../funnels/Cancellation/pages/cnxflightselector';
import { route as cnxPaxSelectorRoute } from '../funnels/Cancellation/pages/cnxpaxselector';
import { route as cnxSummaryRoute } from '../funnels/Cancellation/pages/cnxsummary';
import { route as cnxConfirmationRoute } from '../funnels/Cancellation/pages/cnxconfirmation';
import { route as cnxExitRoute } from '../funnels/Cancellation/pages/exit';
import { route as cnxInfoRoute } from '../funnels/Cancellation/pages/cnxinfo';
import { route as cnxRefundRoute } from '../funnels/Cancellation/pages/cnxrefund';
import { route as cnxRefundoptionsRoute } from '../funnels/Cancellation/pages/cnx_refund_options';
import { route as cnxConfirmationC4arRoute } from '../funnels/Cancellation/pages/cnx_confirmation_c4ar';
import { route as cnxSummaryLCCRoute } from '../funnels/Cancellation/pages/cnxlcc_summary';
import { route as cnxFlightSelectorLCCRoute } from '../funnels/Cancellation/pages/cnxlcc_flightselector';
import { route as cnxStopoverLCCRoute } from '../funnels/Cancellation/pages/cnxslcc_stopovers';
import { route as cnxStepsLCCRoute } from '../funnels/Cancellation/pages/cnxlcc_steps';
import { route as modifyLCRoute } from '../funnels/Modification/pages/modifylc_changetrip';
import { route as modifyStepsLCRoute } from '../funnels/Modification/pages/modifylc_steps';
import { route as modifyStopoversLCRoute } from '../funnels/Modification/pages/modifylc_stopovers';
import { route as modifyFlightsLCRoute } from '../funnels/Modification/pages/modifylc_flightselector';
import { route as mrRoute } from '../funnels/MembershipPages/pages/membershipRetention/membershipRetention';
import { route as mCancellationRoute } from '../funnels/MembershipPages/pages/membershipCancellation/membershipCancellation';
import { route as mCancellationRequestRoute } from '../funnels/MembershipPages/pages/membershipCancellationRequest/membershipCancellationRequest';
import { route as userAreaRoute } from '../funnels/ProfilePages/pages/userArea/userAreaPage';
import { route as cnxAirlineBookingDetailsRoute } from '../funnels/Cancellation/pages/cnxlcc_airline_booking_details';
const checkinMicrofunnel = {
  eventRequestHandler,
  EVENTS,
  OFFERED_INSURANCES_IN_CMF
};
const routes = [resultsRoute, pfHomeRoute, pfOffersRoute, pfPaxRoute, pfPaymentRoute, pfConfirmationRoute, mrrpRoute, mrspRoute, mrcpRoute, mStandaloneCampaignRoute, mStandaloneCheckoutRoute, mStandaloneConfirmationRoute, semResultsRoute, myTripsReactivationRoute, babilling_detailsRoute, barequest_invoiceRoute, baconfirmationRoute, cnxFlightSelectorRoute, cnxPaxSelectorRoute, cnxSummaryRoute, cnxConfirmationRoute, cnxExitRoute, cnxInfoRoute, cnxRefundRoute, cnxRefundoptionsRoute, cnxConfirmationC4arRoute, cnxSummaryLCCRoute, cnxFlightSelectorLCCRoute, cnxStopoverLCCRoute, cnxStepsLCCRoute, modifyLCRoute, modifyStepsLCRoute, modifyStopoversLCRoute, modifyFlightsLCRoute, mrRoute, mCancellationRoute, mCancellationRequestRoute, userAreaRoute, cnxAirlineBookingDetailsRoute];
const createExports = ({
  flightResults
}) => ({
  ...createFlightResultsActions(flightResults),
  checkinMicrofunnel,
  postBookingSeats,
  cabinBags,
  evaluateMembershipProduct,
  homeLoginPopUp,
  flexibilityBundle,
  traveller
});
export const legacyShell = createShell(App, {
  options: {
    routes,
    namespace: 'shell'
  },
  createIntegration,
  createExports,
  createAppProps
});